import { Boots, ItemRarity } from 'game/core'
import { ItemUI } from 'game/extended/uis/item_uis'

import image from './blessed_boots.png'

export const blessed_boots: ItemUI<Boots> = {
    image,
    label: 'Blessed boots',
    value: 160,
    item: {
        key: 'blessed_boots',
        type: 'boots',
        rarity: ItemRarity.Epic,
        stats: {
            intelligence: 50,
            agility: 50,
            energy: 10
        }
    }
}
